export default [
    {
      path: '/main/iccids',
      meta: {
        tag: 'list_iccid',
        name: 'ICCID',
        breadcrumb: 'ICCID',
        menu: 'settings'
      },
      component: () => import(/* webpackChunkName: "search-vehicle" */ '@/views/main/settings/consults/iccid/List.vue')
    }
]